import React from 'react';
import {Alert, Badge, Form, Icon, Input, Button, Select, Row, Col } from 'antd';
import get from 'lodash/get';
import find from "lodash/find";
import map from 'lodash/map';
import { connect } from 'react-redux';

import { updateSiteRequest, createSiteRequest } from "../../api/requests";
import {
  getDrugManagementStatus,
  getSiteCreatePermission,
  getSiteUpdatePermissionBySite
} from "../../reducers/user/selectors";

import classes from './SettingsSiteForm.css';
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from 'react-i18next';

const timezones = require('../../utils/timezones.json');

const { Option } = Select;

class SettingsSiteForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      shortTz: get(find(timezones, ({ utc }) => utc.includes(this.props.time_zone)), 'abbr', ''),
    };
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const site = {...values};
          if (site.manufacturer_id === ""){
            site.manufacturer_id = null;
          }
          if (site.storage_id === ""){  // depot_id
            site.storage_id = null;
          }
          if (site.pharmacy_id === ""){
            site.pharmacy_id = null;
          }
          if (site.fridge_id === ""){
            site.fridge_id = null;
          }

          if (this.props.id) {
            await updateSiteRequest(this.props.code , site);
          } else {
            await createSiteRequest(site);
          }

          this.setState({ isLoading: false, requestResult: { type: 'success', message: this.props.i18n.t('Success') } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', this.props.i18n.t('Error')) } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onChangeTimezone = (value) => {
    const shortTz = get(find(timezones, ({ utc }) => utc.includes(value)), 'abbr', '');
    this.props.form.setFieldsValue({'short_tz': shortTz});
  };

  render() {
    const { isLoading, requestResult, shortTz } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { siteUpdatePermission, siteCreatePermission, id, isNew, pharmacySites, manufacturerSites, fridgeSites, depotSites } = this.props;

    const isEditable = id ? siteUpdatePermission : siteCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.id ? (<span>{this.props.name} <Badge count={this.props.i18n.t('Edit')} style={{ backgroundColor: '#2968AE' }} /></span>) : isNew ? this.props.i18n.t('Add site') : ''}
          </h4>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Code')}:</b>
                <Form.Item>
                  {getFieldDecorator('code', {
                    rules: [{ required: true, message: this.props.i18n.t("Required")}],
                    initialValue: get(this.props, 'code', '')
                  })(
                    <Input disabled={!isEditable} placeholder={this.props.i18n.t('Code')} />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Name')}:</b>
                <Form.Item>
                  {getFieldDecorator('name', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'name', '')
                  })(
                    <Input disabled={!isEditable} placeholder={this.props.i18n.t('Name')} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceSettingsSiteForm:Consent Workflow Type')}:</b>
                <Form.Item>
                  {getFieldDecorator('consent_workflow_type', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'consent_workflow_type', '')
                  })(
                    <Select>
                      {get(this.props.consentSettings, "workflow_type", []).map(
                        (item) => (
                          <Option key={item.id} value={item.value}>
                            {item.name}
                          </Option>
                        )
                      )}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceSettingsSiteForm:Email consent signature order')}:</b>
                <Form.Item>
                  {getFieldDecorator('email_consent_signature_order', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'email_consent_signature_order', '')
                  })(
                    <Select>
                      <Option value='investigator_first'>{this.props.i18n.t('NamespaceSettingsSiteForm:Investigator first (default)')}</Option>
                      <Option value='subject_first'>{this.props.i18n.t('NamespaceSettingsSiteForm:Move Subject first')}</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>


          {(this.props.provider_site_type === 'manufacturer' || get(this.props, 'manufacturer.id', '')) && <Row gutter={12}>
            <Col span={24}>
              <label>
                <b>{this.props.i18n.t('Manufacturer ID')}{this.props.provider_site_type === 'manufacturer' && <span>*</span>}:</b>
                <Form.Item>
                  {getFieldDecorator('manufacturer_id', {
                    rules: [{ required: this.props.provider_site_type === 'manufacturer', message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'manufacturer.id', '')
                  })(
                    <Select disabled={!isEditable} placeholder={this.props.i18n.t('Select')}>
                      {this.props.provider_site_type !== 'manufacturer' && <Option key="" value="">NA</Option>}
                      {map(manufacturerSites, ({ value, label }) => (
                        <Option key={value} value={value}>{label}</Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>}
          {(this.props.provider_site_type === 'depot' || get(this.props, 'storage.id', '')) && <Row gutter={12}>
            <Col span={24}>
              <label>
                <b>{this.props.i18n.t('NamespaceSettingsSiteForm:Drug Depot ID')}{this.props.provider_site_type === 'depot' && <span>*</span>}:</b>
                <Form.Item>
                  {getFieldDecorator('storage_id', {
                    rules: [{ required: this.props.provider_site_type === 'depot', message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'storage.id', '')
                  })(
                    <Select disabled={!isEditable} placeholder={this.props.i18n.t('Select')}>
                      {this.props.provider_site_type !== 'storage' && <Option key="" value="">NA</Option>}
                      {map(depotSites, ({ value, label }) => (
                        <Option key={value} value={value}>{label}</Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>}
          {(this.props.provider_site_type === 'pharmacy' || get(this.props, 'pharmacy.id', '')) && this.props.isDrugManagementActive && <Row gutter={12}>
            <Col span={24}>
              <label>
                <b>{this.props.i18n.t('Pharmacy id')}{this.props.provider_site_type === 'pharmacy' && <span>*</span>}: </b>
                <Form.Item>
                  {getFieldDecorator('pharmacy_id', {
                    rules: [{ required: this.props.provider_site_type === 'pharmacy', message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'pharmacy.id', '')
                  })(
                    <Select disabled={!isEditable} placeholder={this.props.i18n.t('Select')}>
                      {this.props.provider_site_type !== 'pharmacy' && <Option key="" value="">NA</Option>}
                      {map(pharmacySites, ({ value, label }) => (
                        <Option key={value} value={value}>{label}</Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>}
          {(this.props.provider_site_type === 'fridge' || get(this.props, 'fridge.id', '')) && <Row gutter={12}>
            <Col span={24}>
              <label>
                <b>{this.props.i18n.t('Fridge id')}{this.props.provider_site_type === 'fridge' && <span>*</span>}:</b>
                <Form.Item>
                  {getFieldDecorator('fridge_id', {
                    rules: [{ required: this.props.provider_site_type === 'fridge', message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'fridge.id', '')
                  })(
                    <Select disabled={!isEditable} placeholder={this.props.i18n.t('Select')}>
                      {this.props.provider_site_type !== 'fridge' && <Option key="" value="">NA</Option>}
                      {map(fridgeSites, ({ value, label }) => (
                        <Option key={value} value={value}>{label}</Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>}
          <Row gutter={12}>
            <Col span={9}>
              <label>
                <b>{this.props.i18n.t('Location')}:</b>
                <Form.Item>
                  {getFieldDecorator('location', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'location', '')
                  })(
                    <Input disabled={!isEditable} placeholder={this.props.i18n.t('Location')} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={9}>
              <label>
                <b>{this.props.i18n.t('Site Type')}:</b>
                <Form.Item>
                  {getFieldDecorator('site_type', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'site_type', 'randomization')
                  })(
                    <Select disabled={!isEditable} placeholder={this.props.i18n.t('Select')}>
                      <Option value="randomization">{this.props.i18n.t('randomization')}</Option>
                      {this.props.isDrugManagementActive && <Option value="manufacturer">{this.props.i18n.t('NamespaceSettingsSiteForm:manufacturer')}</Option>}
                      {this.props.isDrugManagementActive && <Option value="depot">{this.props.i18n.t('NamespaceSettingsSiteForm:depot')}</Option>}
                      {this.props.isDrugManagementActive && <Option value="pharmacy">{this.props.i18n.t('NamespaceSettingsSiteForm:pharmacy')}</Option>}
                      {this.props.isDrugManagementActive && <Option value="fridge">{this.props.i18n.t('NamespaceSettingsSiteForm:fridge')}</Option>}
                      <Option value="central">{this.props.i18n.t('NamespaceSettingsSiteForm:central')}</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={9}>
              <label>
                <b>{this.props.i18n.t('Time Zone')}:</b>
                <Form.Item>
                  {getFieldDecorator('time_zone', {
                    initialValue: get(this.props, 'time_zone', '')
                  })(
                    <Select showSearch placeholder={this.props.i18n.t('Select')} onChange={this.onChangeTimezone}>
                      <Option value="">{this.props.i18n.t('None')}</Option>
                      {timezones.map(({ utc }) => utc.map((tz, i) => (
                        <Option value={tz} key={i}>{tz}</Option>
                      )))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={6}>
              <label>
                <b>{this.props.i18n.t('NamespaceSettingsSiteForm:Short TZ')}</b>
                <Form.Item>
                  {getFieldDecorator('short_tz', {
                    initialValue: shortTz
                  })( <Input disabled={true} type='text' /> )}
                </Form.Item>
              </label>
            </Col>
            {this.props.site_type === 'randomization' && <Col span={9}>
              <label>
                <b>{this.props.i18n.t('NamespaceSettingsSiteForm:Default locale name')}</b>
                <Form.Item>
                  {getFieldDecorator('locale_name', {
                    initialValue: this.props.locale_name,
                    rules: [{ required: true, message: this.props.i18n.t('Required') }]
                  })(
                    <Select placeholder={this.props.i18n.t("Select")}>
                      <Option value='deCH'>{this.props.i18n.t("Switzerland German")}</Option>
                      <Option value='deDE'>{this.props.i18n.t("Germany German")}</Option>
                      <Option value='enAU'>{this.props.i18n.t("Australia English")}</Option>
                      <Option value='enCA'>{this.props.i18n.t("Canada English")}</Option>
                      <Option value='enUS'>{this.props.i18n.t("United States English")}</Option>
                      <Option value='esUS'>{this.props.i18n.t("United States Spanish")}</Option>
                      <Option value='frCA'>{this.props.i18n.t("Canada French")}</Option>
                      <Option value='frCH'>{this.props.i18n.t("Switzerland French")}</Option>
                      <Option value='itCH'>{this.props.i18n.t("Switzerland Italian")}</Option>
                      <Option value='svSE'>{this.props.i18n.t("Sweden Swedish")}</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>}
          </Row>

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            {isEditable && (<Form.Item>
              <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                {this.props.i18n.t('Save')}
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>)}

            <Button type="default" size="large" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              {this.props.i18n.t('Cancel')}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  isDrugManagementActive: getDrugManagementStatus(state),
  siteCreatePermission: getSiteCreatePermission(state),
  siteUpdatePermission: getSiteUpdatePermissionBySite(get(props, 'id'))(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'site' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SettingsSiteForm)));



// WEBPACK FOOTER //
// ./src/components/SettingsSiteForm/SettingsSiteForm.js